import React, { FunctionComponent } from 'react';
import { faBell } from '@fortawesome/free-solid-svg-icons';
import { BrassIcon, BrassIconProps } from '.';

const BrassIconNotification: FunctionComponent<BrassIconProps> = (
  props: BrassIconProps,
) => <BrassIcon {...props} icon={faBell} />;

export { BrassIconNotification };
